module.exports = __webpack_public_path__ + "static/img/理想AD MAX系统.2f11852b.png";